import React from 'react';
import styled from 'styled-components';
import { FaCheck, FaTimes } from 'react-icons/fa';

const QuestionContainer = styled.div`
  background-color: white;
  border-radius: 15px;
  padding: 2rem;
  margin: 2rem auto;
  max-width: 800px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
`;

const QuestionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;

const QuestionNumber = styled.span`
  background-color: #4169E1;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: bold;
`;

const QuestionText = styled.h2`
  font-size: 1.4rem;
  margin-bottom: 1.5rem;
  line-height: 1.5;
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-top: 2rem;
`;

const TrueFalseButton = styled.button`
  background-color: ${props => 
    props.selected && props.correct ? '#32CD32' : 
    props.selected && !props.correct ? '#FF4757' : 
    props.correct && props.showAnswer ? '#32CD32' : 
    props.option === 'true' ? '#4169E1' : '#FF9500'};
  color: white;
  border: none;
  border-radius: 50px;
  padding: 1rem 3rem;
  font-size: 1.2rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.3s ease;
  width: 180px;
  
  &:hover {
    transform: ${props => props.answered ? 'none' : 'translateY(-3px)'};
    box-shadow: ${props => props.answered ? 'none' : '0 5px 15px rgba(0, 0, 0, 0.2)'};
  }
  
  &:disabled {
    cursor: default;
    opacity: ${props => (props.showAnswer && !props.correct && !props.selected) ? 0.7 : 1};
  }
`;

const FeedbackContainer = styled.div`
  margin-top: 1.5rem;
  padding: 1rem;
  border-radius: 10px;
  background-color: ${props => props.correct ? 'rgba(50, 205, 50, 0.1)' : 'rgba(255, 71, 87, 0.1)'};
  border-left: 5px solid ${props => props.correct ? '#32CD32' : '#FF4757'};
`;

const NextButton = styled.button`
  background-color: #FF9500;
  color: white;
  padding: 0.8rem 2rem;
  border-radius: 25px;
  margin-top: 1.5rem;
  align-self: flex-end;
  font-weight: bold;
  
  &:hover {
    background-color: #FF8000;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
`;

const TrueFalseQuestion = ({ question, isTrue, feedbackCorrect, feedbackIncorrect, questionNumber, totalQuestions, onAnswer, onNext, answered, selectedOption }) => {
  const showAnswer = answered !== null;
  const isCorrect = answered === isTrue;
  
  const handleOptionClick = (option) => {
    if (answered === null) {
      onAnswer(option);
    }
  };

  return (
    <QuestionContainer>
      <QuestionHeader>
        <QuestionNumber>Ερώτηση {questionNumber}/{totalQuestions}</QuestionNumber>
      </QuestionHeader>
      
      <QuestionText>{question}</QuestionText>
      
      <ButtonsContainer>
        <TrueFalseButton 
          onClick={() => handleOptionClick(true)}
          selected={selectedOption === true}
          correct={isTrue === true}
          showAnswer={showAnswer}
          answered={answered !== null}
          disabled={answered !== null}
          option="true"
        >
          Σωστό {showAnswer && selectedOption === true && isCorrect && "👍"}
          {showAnswer && selectedOption === true && !isCorrect && "❌"}
          {showAnswer && isTrue === true && selectedOption !== true && "👍"}
        </TrueFalseButton>
        
        <TrueFalseButton 
          onClick={() => handleOptionClick(false)}
          selected={selectedOption === false}
          correct={isTrue === false}
          showAnswer={showAnswer}
          answered={answered !== null}
          disabled={answered !== null}
          option="false"
        >
          Λάθος {showAnswer && selectedOption === false && isCorrect && "👍"}
          {showAnswer && selectedOption === false && !isCorrect && "❌"}
          {showAnswer && isTrue === false && selectedOption !== false && "👍"}
        </TrueFalseButton>
      </ButtonsContainer>
      
      {showAnswer && (
        <FeedbackContainer correct={isCorrect}>
          {isCorrect ? feedbackCorrect : feedbackIncorrect}
        </FeedbackContainer>
      )}
      
      {showAnswer && (
        <ButtonContainer>
          <NextButton onClick={onNext}>Επόμενη Ερώτηση</NextButton>
        </ButtonContainer>
      )}
    </QuestionContainer>
  );
};

export default TrueFalseQuestion;
